module.exports = __webpack_public_path__ + "img/bronze.449ab8e8.png";